/**
 * @desc 查询挂牌商品分页列表
 */
import { PageListingItem, ListingQuery } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryMallListingPageParameter = ListingQuery

const method = 'GET'
const url = '/trade/mall/listing/page'

export const queryMallListingPageApi = (
  params?: QueryMallListingPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageListingItem>({
    method,
    url,
    params,
    ...config
  })
}

queryMallListingPageApi.method = method
queryMallListingPageApi.url = url
